var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useAppDispatch, useQuery } from '../../hooks';
import * as api from '../../api/matches';
import { setMatchState } from '../../store/match';
import { selectMatchEndCase } from '../../api';
import { useAsyncExecAction } from '../../hooks/useAsyncExecAction';
import { Loader } from '../../components/atoms/Loader/Loader';
import { ModalWrapperNew } from '../../components/atoms/ModalWrapper/ModalWrapper';
import { Delimiter } from '../../components/atoms/Delimiter';
const ModalWrapper = styled(ModalWrapperNew) `
  padding: 40px 30px;
  min-width: 518px;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;
const ButtonsContainer = styled.div `
  display: flex;
  width: 100%;
  justify-content: center;
`;
const EndGameImg = styled.img `
  width: 300px;
  height: 250px;
  display: block;
`;
export function MatchEnd() {
    const { param: matchId } = useQuery('matchId');
    const dispatch = useAppDispatch();
    const { execAsyncAction } = useAsyncExecAction();
    const [loading, setLoading] = useState(false);
    const [winCase, setWinCase] = useState('MAFIA_WIN');
    // console.log('MatchEnd matchState', matchState)
    const matchStateAction = () => __awaiter(this, void 0, void 0, function* () {
        const result = yield api.getMatchState(matchId || '');
        // console.log('Match getMatchState', result)
        dispatch(setMatchState(result));
        // dividePlayers(result.players)
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: matchStateAction });
    });
    useEffect(() => {
        getMatchState();
    }, [matchId]);
    const getSelectMatchEndCaseAction = () => function () {
        return __awaiter(this, void 0, void 0, function* () {
            setLoading(true);
            yield selectMatchEndCase(matchId || '', winCase);
            setLoading(false);
            getMatchState();
        });
    };
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
        yield execAsyncAction({ action: getSelectMatchEndCaseAction() });
    });
    return (_jsx(Paper, Object.assign({ sx: { padding: 3, width: '400px', display: 'flex', flexDirection: 'column' } }, { children: !loading ? (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041A\u0442\u043E \u043F\u043E\u0431\u0435\u0434\u0438\u043B?" })), _jsx(Delimiter, { top: "30px" }), _jsxs(ButtonsContainer, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => setWinCase('MAFIA_WIN'), disabled: winCase === 'MAFIA_WIN' }, { children: "\u041C\u0430\u0444\u0438\u044F" })), _jsx(Delimiter, { right: "10px" }), _jsx(Button, Object.assign({ variant: "outlined", onClick: () => setWinCase('CIVILIANS_WIN'), disabled: winCase === 'CIVILIANS_WIN' }, { children: "\u041C\u0438\u0440\u043D\u044B\u0435" }))] }), _jsx(Delimiter, { top: "24px" }), _jsxs(Button, Object.assign({ variant: "contained", onClick: () => onClick(), sx: { alignSelf: 'center' }, disabled: loading }, { children: ["\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0438\u0433\u0440\u0443 \u043F\u043E\u0431\u0435\u0434\u043E\u0439 ", winCase === 'MAFIA_WIN' ? 'Мафии' : 'Мирных'] }))] })) : (_jsx(Loader, {})) })));
}
